import React from "react"

import StartContentBox from "../Components/StartContentBox"

import ImageBörja from "../Assets/Images/Bildstöd2/börja.svg"
import { evaluationStageType } from "../Models/EvaluationStageType"

import { startButtonText } from "../Utilities/EvaluationStageVariables"
import BackForwardButtonBox from "../Components/BackForwardButtonBox"
import { ActivePage } from "../Models/ActivePageType"
import { AnswersType } from "../Models/AnswersType"

import { PolyglotContext } from "../../../polyglot/polyGlotContext"
import { useContext } from "react"

interface EvaluationStartProps {
    evaluationStage: evaluationStageType;
    setPageToQuestionX: (qNum: number) => void;
    activePage: ActivePage;
    collectedAnswersCopy: AnswersType;
    setCollectedAnswers: React.Dispatch<React.SetStateAction<AnswersType>>;
    collectedAnswers: AnswersType;
}

//Start Page of the Evaluation Tool
const EvaluationStart = ({ evaluationStage, setPageToQuestionX, activePage, collectedAnswersCopy, setCollectedAnswers, collectedAnswers }: EvaluationStartProps) => {
    const { polyglot } = useContext(PolyglotContext);
    let buttonText = startButtonText(evaluationStage, polyglot);

    const backForwardButtonProps = {
        makeVisible: false,
        pageForward: () => { },
        pageBackward: () => { },
        activePage,
        collectedAnswersCopy,
        evaluationStage,
        setCollectedAnswers,
        collectedAnswers,
    };

    return (
        <>
            <BackForwardButtonBox {...backForwardButtonProps} />
            <StartContentBox
                imageA={ImageBörja}
                imageAltA={polyglot.t("evaluationTool.evaluationStart.imgAltA")}
                buttonText={buttonText}
                buttonAction={() => { setPageToQuestionX(1) }}
            />
        </>
    )
}

export default EvaluationStart
